module.exports = __webpack_public_path__ + "img/buyer-mall.b8c84109.png";